module.exports = __webpack_public_path__ + "static/media/qualityCriteriaDE.b55a5a7c.pdf";